import Constants from 'core/constants';
import { hasFeature } from 'core/utils/feature-flags';

const DATE_TIME_DATA_SOURCES = [Constants.DASHBOARD.sourceType.definition];

export const supportsDateTime = (chartType, dataSources) => {
  if (!dataSources?.length) return false;
  const isWordCloud = chartType === Constants.DASHBOARD.chartTypes.wordCloud;
  if (isWordCloud) {
    return wordCloudSupportsDateTime(dataSources);
  } else {
    const { type, schemaId } = dataSources[0];
    return (
      type === Constants.DASHBOARD.sourceType.definition &&
      doesDefinitionSupportDateTime(schemaId)
    );
  }
};

//temporarly limit definitions to DATE_ONLY until we add further support (e.g. to handle DATE_TIME fiscal)
const doesDefinitionSupportDateTime = (schemaId) => {
  return schemaId === Constants.SCHEMAS.INTERACTION_ANALYTICS;
};

const wordCloudSupportsDateTime = (dataSources) => {
  const hasTaTimezonesFeature = hasFeature('ta-timezones');
  if (!hasTaTimezonesFeature) return false;

  if (dataSources.length === 1) {
    const { type } = dataSources[0];
    return isDateTime(type);
  }
  return areDateTime(dataSources);
};

const isDateTime = (type) => DATE_TIME_DATA_SOURCES.includes(type);

const areDateTime = (dataSources) => {
  return dataSources.every((ds) => isDateTime(ds.type));
};
